import Helper from './Helper';

class Breadcrumb {
  constructor() {
    this.breadcrumb = document.querySelector('.wp-breadcrumb');
    this.breadcrumbItem = document.querySelector('.wp-breadcrumb__item');

    this.headerLogo = document.querySelector('.site-header__logo');

    if(this.breadcrumbItem) {
      this.bindLink();
    }
  }

  bindLink() {
    let homeLink = document.createElement('a');

    homeLink.setAttribute('href', this.headerLogo.getAttribute('href'));
    homeLink.classList.add('wp-breadcrumb__item');
    homeLink.classList.add('wp-breadcrumb__item--link');
    homeLink.innerText = this.breadcrumbItem.innerText;

    this.breadcrumbItem.remove();
    this.breadcrumb.insertAdjacentElement('afterbegin', homeLink);
  }

}

export default Breadcrumb;
